import { Loading } from '@/components';
import { useDialog } from '@/hooks/useDialog';
import EventDetailReport from '@/model/EventDetailReport';
import EventGeneralReport from '@/model/EventGeneralReport';
import EventMainBleedingReport from '@/model/EventMainBleedingReport';
import EventMainDateReport from '@/model/EventMainDateReport';
import EventMainPdvReport from '@/model/EventMainPdvReport';
import EventMainReport from '@/model/EventMainReport';
import EventMainSubPdvReport from '@/model/EventMainSubPdvReport';
import EventMainTerminalReport from '@/model/EventMainTerminalReport';
import EventProductReport from '@/model/EventProductReport';
import EventValidationMainReport from '@/model/EventValidationMainReport';
import api from '@/services/api';
import { REACT_APP_USER } from '@/utils/config';
import React, { useEffect, useState } from 'react';
import { /* useHistory, */ useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReportControllerProps, ShouldShowModal, States } from '../types';
import { ReportsContent } from './ui';

export type UrlParams = {
  id: string;
  single: string;
};

export const ReportsScreen: React.FC = () => {
  const params = useParams<UrlParams>();
  const [state, setState] = useState<States>(States.default);
  const [event, setEvent] = useState<EventMainReport>({} as EventMainReport);
  const [eventChild, setEventChild] = useState<EventMainReport[]>([]);
  const [eventDetail, setEventDetail] = useState<EventDetailReport>();
  const [generalSale, setGeneralSale] = useState<EventGeneralReport>();
  const [salePdv, setSalePdv] = useState<EventMainPdvReport[]>();
  const [saleDate, setSaleDate] = useState<EventMainDateReport>();
  const [saleSubpdv, setSaleSubpdv] = useState<EventMainSubPdvReport[]>();
  const [bleeding, setBleeding] = useState<EventMainBleedingReport>();

  const [saleProduct, setSaleProduct] = useState<EventProductReport>();
  const [validation, setValidation] = useState<EventValidationMainReport>();
  const [terminal, setTerminal] = useState<EventMainTerminalReport>();
  const { visible, onToggle } = useDialog();

  const user = JSON.parse(localStorage.getItem(String(REACT_APP_USER)) ?? '{}');
  const { userType } = user;
  const shouldShowModal = ShouldShowModal.detail;

  const handleGetReport = async (): Promise<void> => {
    const singleEvent = params.single === 'true';
    try {
      setState(States.loading);
      const { data } = await api.get<EventMainReport>(
        `event/report/${params.id}?singleEvent=${singleEvent}`,
      );
      if (data) {
        setEvent(data);
        if (data.childs && data.childs.length > 0) {
          setEventChild(data.childs);
        }
      }
    } catch (error) {
      toast.error('Evento sem relatórios disponíveis');
    } finally {
      setState(States.default);
    }
  };

  const handleOnChildPress = async (eventSelected: string, eventName: string): Promise<void> => {
    if (eventSelected !== event.id || eventName === event.name) {
      window?.open(
        `${window.location.origin}/dashboard/event/reports/${eventSelected}/true`,
        '_blank',
      );

      /*
      history.push(`/dashboard/event/reports/${eventSelected}/true`);

      try {
        setState(States.loading);
        setEvent({} as EventMainReport);
        setEventChild([]);
        setEventDetail(undefined);
        setGeneralSale(undefined);
        setSalePdv(undefined);
        setSaleDate(undefined);
        setSaleSubpdv(undefined);
        setBleeding(undefined);
        setTracking(undefined);
        setTrackingPagination({
          page: 1,
          pageSize: 10,
          total: 0,
        });
        setSaleProduct(undefined);
        setValidation(undefined);
        setTerminal(undefined);
        const { data } = await api.get<EventMainReport>(
          `event/report/${eventSelected}?singleEvent=true`,
        );
        if (data) {
          setEvent(data);
          if (data.childs && data.childs.length > 0) {
            setEventChild(data.childs);
          }
        }
      } catch (error) {
        toast.error('Evento sem relatórios disponíveis');
      } finally {
        setState(States.default);
      }
      */
    }
  };

  const handleGetDetailReport = async (): Promise<void> => {
    try {
      setState(States.loading);
      const singleEvent = params.single === 'true';
      const { data } = await api.get<EventDetailReport>(
        `event/report/${params.id}/detail?singleEvent=${singleEvent}`,
      );
      if (data) {
        setEventDetail(data);
      } else {
        setEventDetail(undefined);
      }
    } catch (error) {
      toast.error('Evento sem relatórios disponíveis');
    } finally {
      setState(States.default);
    }
  };

  const reportController: ReportControllerProps = {
    eventId: params.id,
    singleEvent: params.single === 'true',
    generalSale,
    salePdv,
    saleDate,
    saleSubpdv,
    bleeding,
    // tracking,
    // trackingPagination,
    saleProduct,
    validation,
    terminal,
    setGeneralSale,
    setSalePdv,
    setSaleDate,
    setSaleSubpdv,
    setBleeding,
    // setTracking,
    // setTrackingPagination,
    // onPageTracking,
    setSaleProduct,
    setValidation,
    setTerminal,
  };

  const handleOnShowModal = async (): Promise<void> => {
    if (!visible) {
      await handleGetDetailReport();
    }
    onToggle();
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const generatePDF = () => {
    window.print();
  };

  useEffect(() => {
    handleGetReport();
  }, []);

  return (
    <>
      <Loading isVisible={state === 'loading'} />
      {event && event.ticket && (
        <ReportsContent
          event={event}
          shouldShowModal={shouldShowModal}
          visible={visible}
          reportController={reportController}
          eventChild={eventChild}
          userId={user.id}
          userType={userType}
          eventDetail={eventDetail}
          onChildPress={handleOnChildPress}
          onShowModal={handleOnShowModal}
          generatePDF={generatePDF}
          onToggle={onToggle}
        />
      )}
    </>
  );
};
